import React, { forwardRef, HTMLAttributes } from 'react';
import Utils from '../../../../utils/Utils';

type JobCardUiv2ContainerProps = HTMLAttributes<HTMLDivElement>;

export const JobCardUiv2Container = forwardRef<HTMLDivElement, JobCardUiv2ContainerProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={Utils.cn(
          'flex w-full max-w-full min-h-[114px] gap-4 rounded-[12px] border border-solid border-gray-200 bg-white px-[15px] py-3',
          className,
        )}
        {...props}>
        {children}
      </div>
    );
  },
);
JobCardUiv2Container.displayName = 'JobCardUiv2Container';
